// StatCard.js - Option 2: Minimal with Progress Ring
import styles from './StatCard.module.css';

function StatCard({ title, value, icon, color, type = 'neutral', subtitle, progress = 0, maxProgress = 100 }) {
  // Calculate progress percentage for the ring
  const percentage = Math.min((progress / maxProgress) * 100, 100);
  const circumference = 2 * Math.PI * 45; // radius = 45
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  
  return (
    <div className={styles.card} data-type={type}>
      <div className={styles.ringContainer}>
        <svg className={styles.progressRing} viewBox="0 0 100 100">
          {/* Background circle */}
          <circle
            className={styles.ringBg}
            cx="50"
            cy="50"
            r="45"
            fill="none"
            strokeWidth="6"
          />
          {/* Progress circle */}
          <circle
            className={styles.ringProgress}
            cx="50"
            cy="50"
            r="45"
            fill="none"
            strokeWidth="6"
            style={{
              stroke: color,
              strokeDasharray: circumference,
              strokeDashoffset: strokeDashoffset,
            }}
          />
        </svg>
        <div className={styles.ringContent}>
          <span className={styles.icon}>{icon}</span>
        </div>
      </div>
      <div className={styles.info}>
        <span className={styles.value}>{value}</span>
        <span className={styles.title}>{title}</span>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </div>
    </div>
  );
}

export default StatCard;